export default __webpack_public_path__ + "static/media/save-history.daae3f20.svg";